import { UntypedFormGroup } from "@angular/forms";
import moment from 'moment-timezone';

interface IValidation {
  hours: boolean;
  nextDay: boolean;
  overlap: boolean;
  validTime: boolean
}

interface ITimeValue {
  hours: string | number;
  minutes: string | number
}

interface IFormGroupValue {
  hoursFirstValueFirstArray: ITimeValue | "";
  hoursFirstValueSecondArray: ITimeValue | "";
  hoursSecondValueFirstArray: ITimeValue | "";
  hoursSecondValueSecondArray: ITimeValue | "";
  nextDay: boolean;
  closed: boolean
}

export function timepickerValidator(formGroup: UntypedFormGroup) {
  const value: IFormGroupValue = formGroup.value;
  let hours = false,
      nextDay = false,
      overlap = false,
      validTime = false;

  const timeRegexp = /^([01]?[0-9]|2[0-3]):[0-5]?[0-9]$/;
  const dateStr = '1970-01-01';
  const dateFmt = 'YYYY-MM-DD HH:mm';

  let hoursItem = [[value.hoursFirstValueFirstArray, value.hoursSecondValueFirstArray]];
  if(value?.hoursFirstValueSecondArray && (typeof value.hoursFirstValueSecondArray || typeof value.hoursSecondValueSecondArray) !== 'string') {
    hoursItem.push([value.hoursFirstValueSecondArray, value.hoursSecondValueSecondArray])
  }

  const filteredHours = hoursItem.filter((a) => {
    return (typeof a[0] && typeof a[1]) !== 'string';
  });
  if(!filteredHours.length) {
    setValidation(null);
    return null;
  }

  let openTimes = hoursItem.map((a) => {
    const timestamp = a.map((t) => {
      return moment.utc(`${dateStr} ${t['hours']}:${t['minutes']}`, dateFmt).valueOf();
    });
    validTime = !timeRegexp.test(convertTimeFormat(a[0])) || !timeRegexp.test(convertTimeFormat(a[1]));
    return timestamp;
  });

  function convertTimeFormat(t) {
    return `${t['hours']}:${t['minutes']}`;
  }

  if (!value.closed && !value.nextDay && openTimes.length > 1 && !validTime) {
    // sort by open times
    openTimes = openTimes.sort((a, b) => a[0] - b[0]);
    // times don't overlap if first close time < second open time
    overlap = !(openTimes[0][1] < openTimes[1][0]);
  } else {
    // if there's only one set of hours, there can't be overlap
    overlap = false;
  }

  for (let a = 0; a < openTimes.length; a++) {
    if (!value.closed && !value.nextDay && openTimes[a][0] >= openTimes[a][1] && !validTime) {
      hours = true;
    }
    if (!value.closed && value.nextDay && openTimes[a][0] <= openTimes[a][1] && !validTime) {
      nextDay = true;
    }
  }

  const validation = hours || nextDay || overlap || validTime ? { hours, nextDay, overlap, validTime} : null;
  setValidation(validation);

  function setValidation(validation: IValidation | null): void {
    formGroup.controls['hoursFirstValueFirstArray'].setErrors(validation);
    formGroup.controls['hoursSecondValueFirstArray'].setErrors(validation);
    if(value?.hoursFirstValueSecondArray || value?.hoursSecondValueSecondArray) {
      formGroup.controls['hoursFirstValueSecondArray'].setErrors(validation);
      formGroup.controls['hoursSecondValueSecondArray'].setErrors(validation);
    }
  }

  return validation;
}
